import React, { useState, useCallback, useEffect } from 'react';
import clsx from 'clsx';
import './Accounts.scss';
import ThreeDotsLoader from '../../Icons/ThreeDotsLoader';

interface IAccounts {
  onConfirm: (path: string, save: boolean) => void
  accounts: string[]
  loadMoreAccounts: () => Promise<void> | any
  error: string
  loading: boolean
  connecting: boolean
  connectionError: string
  walletName: string
}

const Accounts: React.FC<IAccounts> = ({
  onConfirm,
  accounts = [],
  loadMoreAccounts,
  error = '',
  loading = false,
  connecting = false,
  connectionError = '',
  walletName,
}) => {
  const [path, setPath] = useState('0');
  const [save, setSave] = useState(true);
  const onPathClick = useCallback(({ target: { dataset } }) => {
    setPath(dataset.path);
  }, []);
  const onCheckboxChange = useCallback(({ target }) => {
    setSave(target.checked);
  }, []);
  const onClick = useCallback(() => {
    onConfirm(path, save);
  }, [onConfirm, path, save]);

  useEffect(() => {
    loadMoreAccounts();
  }, []);

  return (
    <div className="web3-wc_hd-wallet__accounts web3-wc_hd-wallet__common-container">
      <h4>Available {walletName} Accounts</h4>
      <div className="web3-wc_hd-wallet__accounts-list">
        {(!!accounts.length || loading) && (
          <>
            <div className="web3-wc_hd-wallet__list_container">
              {accounts.map((account, index) => (
                <div className={clsx('web3-wc_hd-wallet__list-item', { active: path === index.toString() })} data-path={index} key={account} onClick={onPathClick}>
                  {account.replace(/^(0x.{5}).{28}/, '$1....')}
                </div>
              ))}
            </div>
            {!(error || connectionError) && (
              <div className="web3-wc_hd-wallet__accounts-list-btn-container">
                {!connecting && !!accounts.length && !loading && (
                  <button type="button" onClick={loadMoreAccounts} className="web3-wc_hd-wallet_load_more">Load more +</button>
                )}
                {!connecting && !!accounts.length && !loading && (
                  <div className="web3-wc_common-checkbox">
                    <input type="checkbox" id="save-ledger-path" checked={save} onChange={onCheckboxChange} />
                    <label htmlFor="save-ledger-path">Remember me</label>
                  </div>
                )}
                {(loading || connecting) && (
                  <div className={clsx('web3-wc_hd-wallet__accounts-list-loader-container', { absolute: !accounts.length })}>
                    <ThreeDotsLoader big />
                  </div>
                )}
              </div>
            )}
          </>
        )}
        {(error || connectionError) && <div className={clsx('web3-wc_hd-wallet_error', { standalone: !accounts.length })}>{error || connectionError}</div>}
      </div>
      <button type="button" className="web3-wc_hd-wallet_warning_confirm" onClick={onClick} disabled={connecting || loading}>Confirm</button>
    </div>
  );
};

export default Accounts;
